<template>
  <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page" :page-sizes="size_list"
    :page-size="size" layout="total, sizes, prev, pager, next, jumper" :total="total">
  </el-pagination>
</template>

<script>
  export default {
    created() {
      this.getTotalsize();
    },
    methods: {
      getTotalsize(keywords) {
        if (!keywords) keywords = '';
        this.$getJSON("/radio/cnt_whitelst", {
          keywords
        }).then(res => {
          this.total = res.data[0].count;
        });
      },
      handleSizeChange(a) {
        this.size = a;
        this.$emit("change", {
          page: this.page,
          size: this.size
        });
      },
      handleCurrentChange(a) {
        this.page = a;
        this.$emit("change", {
          page: this.page,
          size: this.size
        });
      }
    },
    data() {
      return {
        page: 1,
        size_list: [10, 20, 30, 40],
        size: 10,
        total: 400
      };
    }
  };

</script>

<style scoped>
  .el-pagination {
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/WhiteList/PageNation.vue